import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { initNativeShell } from '../utils/nativeInit';
import { initPushNotifications, teardownPushNotifications } from '../utils/pushNotifications';

/** Wires Capacitor native features once auth state is known. */
function NativeShell() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    initNativeShell();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      initPushNotifications();
    } else {
      teardownPushNotifications();
    }
  }, [isAuthenticated]);

  return null;
}

export default NativeShell;
